;window.readMore = (function ($) {

		"use strict";

		var readMore = {
		    // parent carousel
		    carousel: null,
		    slickList: null,

		    fullVersionClass: '.teamCarousel__fullVersion',
		    slideInitHeight: 'auto',
		    clickElClass: '.teamCarousel__readMore',
		    closeElClass: '.teamCarousel__closeWrap',

	    	init: function() {
				// cause fulltext version transition height
				readMore.prepareDataAttrOfTextEl();
				$(window).on('resize', function() {
					readMore.prepareDataAttrOfTextEl();
				});

				// register click on 'read more' button
				$(readMore.clickElClass).on('click', function() {
					readMore.showFullVersion($(this));
				});

				// register click on 'close' button
				$(readMore.closeElClass).on('click', function() {
					readMore.hideFullVersion();
				});
	    	},

		    // clicked - clicked elem to show fulltext version
		    showFullVersion: function(clicked) {

				// Carousel preparing
				readMore.carousel = clicked.closest('.teamCarousel');
				readMore.slickList = readMore.carousel.find('.slick-list');
				readMore.slideInitHeight = readMore.slickList.css('height');
				readMore.slickList.css('height', 'auto');
				readMore.carousel.addClass('teamCarousel--disable');
				setTimeout(function() {
					readMore.carousel.find('.slick-dots, .slick-arrow').addClass('hidden');
				}, 300);

				clicked.addClass('teamCarousel__readMore--hidden');
				// $('.teamCarousel__shortVersion').addClass('teamCarousel__shortVersion--hidden');

				// text elem expand cause fullversion
				var textEl = readMore.carousel.find('.teamCarousel__text');
				// textEl.css('max-height', textEl.attr('data-maxHeight'));
				$(readMore.fullVersionClass).addClass('teamCarousel__fullVersion--active');

				// hide text head
				textEl.find('.teamCarousel__textHead').addClass('teamCarousel__textHead--hidden');

				// close buttons show
				readMore.showCloseButtons(textEl);

				// no draggable carousel if fulltext
				readMore.setCarouselDraggable(readMore.carousel, false);
		    },

			hideFullVersion: function() {

				// not ok to use class properties, cause not call init necessary
				var fulltext = $('.teamCarousel__fullVersion--active');

				if (fulltext.length) {
					var carousel = fulltext.closest('.teamCarousel');
					var textEl = carousel.find('.teamCarousel__text');

					readMore.hideCloseButtons(textEl);
					// textEl.css('max-height', textEl.attr('data-minHeight'));

					carousel.removeClass('teamCarousel--disable');
					setTimeout(function() {
						var height = carousel.find('.slick-track').innerHeight();
						carousel.find('.slick-list').css('height', height + 'px');
						readMore.carousel.find('.slick-dots, .slick-arrow').removeClass('hidden');
						textEl.find(readMore.fullVersionClass).removeClass('teamCarousel__fullVersion--active');
						textEl.find(readMore.clickElClass).removeClass('teamCarousel__readMore--hidden');
						$(".teamCarousel__textHead--hidden").removeClass('teamCarousel__textHead--hidden');

						// enable draggable
						readMore.setCarouselDraggable(readMore.carousel, true);
					}, 300);
				}
			},

			showCloseButtons: function(parentEl) {
				if (parentEl) {
					setTimeout(function() {
						parentEl.find(readMore.closeElClass).removeClass('teamCarousel__closeWrap--hidden');
						parentEl.find(readMore.closeElClass).addClass('teamCarousel__closeWrap--visible');
					}, 300);
				}
			},

			hideCloseButtons: function(parentEl) {
				if (parentEl) {
					parentEl.find(readMore.closeElClass).removeClass('teamCarousel__closeWrap--visible');
					setTimeout(function() {
						parentEl.find(readMore.closeElClass).addClass('teamCarousel__closeWrap--hidden');
					}, 300);
				}
			},

			prepareDataAttrOfTextEl: function() {
				var textEl = $('.teamCarousel').find('.teamCarousel__text');

				if (textEl.length) {
					var minHeight = textEl.innerHeight();
					var fulltextHeight = textEl.find('.teamCarousel__fullVersion').innerHeight() * 2;
					// textEl.css('max-height', minHeight);
					textEl.attr('data-minHeight', minHeight + 'px');
					textEl.attr('data-maxHeight', fulltextHeight + 'px' );
				}
			},

			setCarouselDraggable: function(carousel, setting) {
				$(carousel).slick("slickSetOption", "draggable", setting, false);
				$(carousel).slick("slickSetOption", "swipe", setting, false);
			}
		};

	  	return readMore;

})(jQuery);

(function($){
	if ( $('.teamCarousel').length ) {
		$('.teamCarousel').slick();
	}

	// Carousel members - init readMore
	readMore.init();

}(jQuery));